export const DWELL_ROUTES = {
    sddwell: {
        path: "/dwellingBoard/sd"
    },
    dwell: {
        path: "/dwellingBoard"
    }
};


// WEBPACK FOOTER //
// ./src/commons/constants/RouteConstants.js